<template>
  <v-dialog
    v-model="dialogeditphone"
    width="450"
  >
    <v-card style="border-radius:14px;">
        <v-card-title class="headerType" >
          {{$t('Settings.messageEditPhone.TitleDialogEdit')}}
          <v-spacer></v-spacer>
           <v-btn flat icon color="grey" class="closeIcon" @click="cancle()">
              <v-icon>close</v-icon>
            </v-btn>
        </v-card-title>

    <v-stepper v-model="e1">
    <!-- <v-stepper-header>
      <v-stepper-step :complete="e1 > 1" step="1">Name of step 1</v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step :complete="e1 > 2" step="2">Name of step 2</v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step step="3">Name of step 3</v-stepper-step>
    </v-stepper-header> -->
    <v-stepper-items>
      <v-stepper-content step="1">
        <span class="headerContent">{{$t('Settings.messageEditPhone.MsgPhoneRegistered')}}</span>
        <p style="font-size:14px;">
          {{$t('Settings.messageEditPhone.MsgDetectPhone')}} {{phoneedit}} {{$t('Settings.messageEditPhone.MsgDetectPhonenext')}}
          <!-- ตรวจพบหมายเลข {{this.phoneedit}} มีการลงทะเบียนใช้งานระบบแล้ว คุณสามารถเข้าสู่ระบบอีกครั้งเพื่อใช้งานบัญชีดังกล่าวได้ทันที -->
          </p>

        <v-radio-group v-model="radios" column class="pl-3">

          <v-radio value="closeRecent" >
            <template slot="label">
              <div>
                <strong style="color:black; font-size:14px;">{{$t('Settings.messageEditPhone.MsgCloseAccountSelect')}}</strong>
                <br>
                <span style="color:grey; font-size:14px;">{{$t('Settings.messageEditPhone.MsgCloseAccountSpan')}} {{phone}} </span>
            </div>
            </template>
          </v-radio>
          <v-radio value="keepAccount">
            <template slot="label">
              <div>
                <strong style="color:black; font-size:14px;">{{$t('Settings.messageEditPhone.MsgKeepAccountSelect')}}</strong>
                <br>
                <span style="color:grey; font-size:14px;">{{$t('Settings.messageEditPhone.MsgKeepAccountSpan')}}</span>
              </div>
            </template>
          </v-radio>
        </v-radio-group>

        <v-layout justify-end>
          <v-btn
            color="primary"
            @click="checkValue()"
            :disabled="disablebtnST1()"
          >
            {{$t('AnswerQuestion.continue')}}
          </v-btn>

          <v-btn dark  color="red" @click="cancle()">{{$t('AnswerQuestion.cancel')}}</v-btn>
        </v-layout>
      </v-stepper-content>

      <v-stepper-content  step="2">
        <v-card
          flat
          v-if="radios === 'closeRecent'"
          class="mb-2"
          height="200px"
        >

        <v-btn icon flat @click="e1 = 1" class="previcon">
          <v-icon style="font-size: 14px !important; cursor:pointer;">fas fa-chevron-left</v-icon>
        </v-btn>
        <span class="headerContent pl-2" >{{$t('Settings.messageEditPhone.MsgCloseOnechatAccount')}}</span>
       <v-flex xs12 sm12 md12>
        <p style="font-size:14px; padding-left:30px;" >{{$t('Settings.messageEditPhone.MsgCloseOnechatAccountSpan')}}</p>
       </v-flex>
        <v-radio-group v-model="radios2" column class="pl-3">
          <v-radio value="closeAccount">
            <template slot="label">
              <div>
                <span style="color:grey; font-size:14px;">
                  {{$t('Settings.messageEditPhone.MsgCloseOnechatAccountSelect')}}
                </span>
            </div>
            </template>
          </v-radio>
        </v-radio-group>
        </v-card>
        <v-layout justify-end>
          <!-- @click="e1 = 3" -->
          <v-btn
            color="primary"

            @click="Terminate()"
            :disabled="disablebtnST2()"
          >
            {{$t('AnswerQuestion.continue')}}
          </v-btn>

          <v-btn dark color="red" @click="cancle()">{{$t('AnswerQuestion.cancel')}}</v-btn>
        </v-layout>
      </v-stepper-content>

      <v-stepper-content step="3">
        <span class="headerContent">{{$t('Settings.messageEditPhone.MsgConfirmCloseAccount')}}</span>
        <p style="font-size:14px; margin-bottom:0px;">{{$t('Settings.messageEditPhone.MsgSendOTP')}} {{this.phone}}</p>
        <p style="font-size:14px;">
          refcode :
            <v-progress-circular v-if="progressTerminate === true"
              :indeterminate="progressTerminate"
              color="grey"
              size="20"
            ></v-progress-circular>
            <span v-else>{{refcode_terminate}}</span>
            <!--  -->
        </p>
        <div style="padding: 16px; padding-bottom:0px; " >
        <v-layout justify-center>
          <!-- {{ countDown }} -->
          <OtpInput
            ref="otpInputTerminate"
            input-classes="otp-input"
            separator="-"
            :num-inputs="6"
            :should-auto-focus="true"
            :is-input-num="true"
            @on-change="handleOnChange"
            @on-complete="handleOnCompleteTerminate"
          />
        </v-layout>
        <v-layout row class="pt-3">
            <span v-if="counting2 === true">{{$t('Settings.messageEditPhone.MsgOTPNotrecieve')}}</span>
            <span v-else>{{$t('Settings.messageEditPhone.MsgOTPAgain')}}</span>
            <v-icon class="pl-2" @click="newOtp2()" v-if="counting2 === false" style="cursor:pointer;">mdi-refresh</v-icon>
          <v-spacer></v-spacer>
            <countdown v-if="counting2 === true" :time="300000" @end="handleCountdownEnd2" :transform="transform" @progress="handleCountdownProgress">
              <template slot-scope="props"> {{$t('Settings.messageEditPhone.MsgResendOTP')}} {{ props.minutes }}:{{ props.seconds }} </template>
            </countdown>
        </v-layout>
            </div>
        <v-layout justify-center class="pt-2 pb-2 pl-2 pr-2">
          <v-btn
            color="primary"
            :disabled="disableBtn()"
            :loading="loadingOtpTerminate"
            @click="sendOTPterminate()"
          >
            {{$t('AnswerQuestion.continue')}}
          </v-btn>
          <v-btn dark color="red" @click="cancle()">{{$t('AnswerQuestion.cancel')}}</v-btn>
        </v-layout>
        <!-- <v-layout justify-center v-if="otp_off === true">
          <v-btn color="primary" >ขอ otp อีกครั้ง</v-btn>
        </v-layout> -->
      </v-stepper-content>

      <v-stepper-content step="4">
        <span class="headerContent">{{$t('Settings.messageEditPhone.MsgVerifyPhone')}}</span>
        <p style="font-size:14px;  margin-bottom:0px;">
          <!-- เราได้ส่งรหัส 6 หลักไปยังหมายเลข {{this.phoneedit}} -->
          {{$t('Settings.messageEditPhone.MsgSendOTP')}}  {{this.phoneedit}}
        </p>
        <p style="font-size:14px;">
          refcode :
          <v-progress-circular v-if="progress === true"
            :indeterminate="progress"
            color="grey"
            size="20"
          ></v-progress-circular>
          <span v-else>{{refcode_terminate}}</span>
        </p>
        <div style="padding: 16px; padding-bottom:0px; " >
        <v-layout justify-center>
          <!-- {{ countDown }} -->
          <OtpInput
            ref="otpInput"
            input-classes="otp-input"
            separator="-"
            :num-inputs="6"
            :should-auto-focus="true"
            :is-input-num="true"
            @on-change="handleOnChange"
            @on-complete="handleOnComplete"
          />
        </v-layout>
        <v-layout row class="pt-3">
            <span v-if="counting === true">{{$t('Settings.messageEditPhone.MsgOTPNotrecieve')}}</span>
            <span v-else>{{$t('Settings.messageEditPhone.MsgOTPAgain')}} </span>
            <v-icon class="pl-2" @click="newOtp()" v-if="counting === false" style="cursor:pointer;">mdi-refresh</v-icon>
          <v-spacer></v-spacer>
            <countdown v-if="counting === true" :time="300000" @end="handleCountdownEnd" :transform="transform" @progress="handleCountdownProgress">
              <template slot-scope="props"> {{$t('Settings.messageEditPhone.MsgResendOTP')}} {{ props.minutes }}:{{ props.seconds }} </template>
            </countdown>




        </v-layout>
            </div>
        <v-layout justify-center class="pt-2 pb-2 pl-2 pr-2">
          <v-btn
            color="primary"
            :loading="loadingOtpNewno"
            :disabled="disableBtn()"
            @click="sendOTP()"
          >
            {{$t('AnswerQuestion.continue')}}
          </v-btn>
          <v-btn dark color="red" @click="cancle()">{{$t('AnswerQuestion.cancel')}}</v-btn>
        </v-layout>
        <!-- <v-layout justify-center v-if="otp_off === true">
          <v-btn color="primary" >ขอ otp อีกครั้ง</v-btn>
        </v-layout> -->
      </v-stepper-content>
    </v-stepper-items>
  </v-stepper>
    </v-card>
  </v-dialog>
</template>

<script>
import Vue from 'vue'
import { Decode } from '@/services'
import OtpInput from "@bachdgvn/vue-otp-input";
import moment from 'moment'
import VueCountdown from '@chenfengyuan/vue-countdown'
Vue.component(VueCountdown.name, VueCountdown)
export default {
  components:{
   OtpInput
  },
  props: {
    dialogeditphone: Boolean,
    phoneedit: String,
    phone: String
  },
  data: () => ({
      state_edit : false,
      // date: moment(60 * 5 * 1000),
      radios:'',
      e1: 1,
      radios2:'',
      complete: '',
      interv: '',
      otpinput: '',
      otpinput_terminate: '',
      otp_off: false,
      refcode_terminate: '',
      token: '',
      OTP: '',
      counting: false,
      counting2: false,
      phonenewtologin: '',
      date: moment(60 * 5 * 1000),
      interv: '',
      progress: false,
      loadingOtpNewno: false,
      loadingOtpTerminate: false,
      progressTerminate: false

      // countDown : 10
  }),
  computed: {
    time () {
      // console.log(this.date.format('mm:ss'))
      return this.date.format('mm:ss')
    }
  },
  created () {
    var decoded =  JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
    this.token = decoded['tokenuser']
    // console.log(this.token)
  },
  mounted () {

  },
  watch:{
    dialogeditphone () {
      this.otpinput_terminate = ''
      this.otpinput = ''
      if(this.dialogeditphone === true){
        this.phonenewtologin = this.phoneedit
        //
        var type_account = localStorage.typeAccount
        if(type_account === 'true'){
          this.progress = true
          this.axios.post(process.env.APImanage + '/otp_change_phone', {
            new_phone: this.phoneedit,
            tokenuser: this.token
          }).then((response)=> {
            console.log(response)
            if(response.data.status === 'success'){
              this.progress = false
              this.refcode_terminate = response.data.refcode
            }else if (response.data.message === 'refresh_token expire'){
              this.$swal({
                title: this.$t('Settings.messageEditPhone.MsgTokenExpire'),
                type: 'warning'
              })
            }else if (response.data.message === 'too many requests.'){
              this.refcode_terminate = ''
              this.$swal({
                title: this.$t('Settings.messageEditPhone.MsgTooManyRequest'),
                type: 'warning'
              })
            }
          }).catch((err)=>{
            console.log(err)
          })
          this.e1 = 4
          this.counting = true
        }
        else{
          this.e1 = 1
        }
      }
    },
    e1 () {
      if(this.e1 === 3 ){
        this.counting2 = true
      }
    }
  },
  methods: {
    handleOnChange(value) {
      if(value.length < 6){
        this.complete = false
      }
      // console.log('OTP changed: ', value);
    },
    handleOnComplete(value) {
      // console.log('OTP complete: ', value);
      this.otpinput = value
      this.complete = true
    },
    handleOnChangeTerminate (value){
      if(value.length < 6){
        this.complete = false
      }
      // console.log('OTP changed: ', value);
    },
    handleOnCompleteTerminate(value) {
      // console.log('OTP completed: ', value);
      this.otpinput_terminate = value
      this.complete = true
    },
    disableBtn() {
      // return true
      if(this.complete === true){
        return false
      }else {
        return true
      }
    },
    sendOTPterminate() {
      this.loadingOtpTerminate = true
      this.axios.post(process.env.APImanage + '/terminate_phone', {
        phone:this.phone,
        otp: this.otpinput_terminate
      }).then((response)=> {
        // console.log(response)
        if(response.data.message === 'terminate success'){
          this.loadingOtpTerminate = false
          this.$swal({
            title: this.$t('Settings.messageEditPhone.MsgLoginPhoneAgain'),
            type: 'warning'
          }).then((result)=>{
            // console.log(result)
            if(result){
              this.$emit('closeDialogEditPhone', false)
              this.$refs.otpInput.clearInput();
              this.radios = ''
              this.radios2 = ''
              localStorage.removeItem("typeAccount")
              this.logout()
              localStorage.tologin = this.phonenewtologin
            }
          })
        }else{
          this.loadingOtpTerminate = false
          this.$swal({
            title: this.$t('Settings.messageEditPhone.OTPInvalid'),
            type: 'error'
          })
        }
        // else{
        //   console.log('error')
        // }
      }).catch((err)=>{
        console.log(err)
      })
    },
    sendOTP () {
      this.loadingOtpNewno = true
      var type_account = localStorage.typeAccount
        this.axios.post(process.env.APImanage + '/confirm_otp_change_phone', {
          new_phone:this.phoneedit,
          otp:this.otpinput,
          tokenuser:this.token
        }).then((response)=> {
          // console.log(response)
            if(type_account === 'true'){
              if(response.data.message === 'login success'){
                this.loadingOtpNewno = false
                this.$swal({
                  title: this.$t('Settings.messageEditPhone.MsgChangePhoneSuccess'),
                  type: 'success'
                }).then((result) => {
                  if(result){
                    this.$emit('closeDialogEditPhone', false)
                    this.$refs.otpInput.clearInput();
                    this.radios = ''
                    this.radios2 = ''
                    localStorage.removeItem("typeAccount")
                    localStorage.phone = this.phoneedit
                    localStorage.editphone_success = true
                  }
                  // else{
                  //   this.phoneedit = this.phone
                  // }
                })
              }else if (response.data.message === 'OTP Invalid') {
                this.loadingOtpNewno = false
                localStorage.editphone_success = false
                this.$swal({
                  title: this.$t('Settings.messageEditPhone.OTPInvalid'),
                  type: 'error'
                })
              }else if(response.data.message === 'too many requests.'){
                this.loadingOtpNewno = false
                this.refcode_terminate = ''
                this.$swal({
                title: this.$t('Settings.messageEditPhone.MsgTooManyRequest'),
                type: 'warning'
                })
              }
            }else{
              if(this.radios2 !== '') {
                this.$swal({
                  title: this.$t('Settings.messageEditPhone.MsgLoginPhoneAgain'),
                  type: 'warning'
                }).then((result)=>{
                  if(result){
                    this.$emit('closeDialogEditPhone', false)
                    // clearInterval(this.interv)
                    this.date = moment(60 * 5 * 1000)
                    this.$refs.otpInput.clearInput();
                    this.radios = ''
                    this.radios2 = ''
                    localStorage.removeItem("typeAccount")
                    this.logout()
                  }
                })
              }
            }
          }).catch((err)=>{
            console.log(err)
          })
    },
    cancle() {
      this.$swal({
        title: this.$t('Alert.Right.cancleEditPhone'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then((result) => {
        // console.log(result.value)
        if(result.value === true){
          this.$emit('closeDialogEditPhone', false)
          this.handleCountdownEnd()
          // clearInterval(this.interv)
          // this.date = moment(60 * 5 * 1000)
          this.$refs.otpInputTerminate.clearInput();
          this.$refs.otpInput.clearInput();
          this.radios = ''
          this.radios2 = ''
          localStorage.removeItem("typeAccount")
          // localStorage.phoneedit = this.phone
          // this.phoneedit = this.phone
          localStorage.editphone_success = false
        }
      })
    },
    checkValue () {
      if(this.radios === 'closeRecent'){
        this.e1 = 2
      }
      else {
        this.$swal({
          title: this.$t('Settings.messageEditPhone.MsgSwitchAccount'),
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '',
          confirmButtonText: this.$t('AnswerQuestion.ok'),
          cancelButtonText: this.$t('AnswerQuestion.cancel'),
          confirmButtonClass: 'btn btn-danger',
          cancelButtonClass: 'btn btn-success',
          buttonsStyling: true,
          showCloseButton: true,
          reverseButtons: true
        }).then((result) => {
          if(result.value === true){
            this.$emit('closeDialogEditPhone', false)
            this.handleCountdownEnd()
            this.$refs.otpInput.clearInput();
            this.radios = ''
            this.radios2 = ''
            localStorage.removeItem("typeAccount")
            this.$swal({
              title: this.$t('Settings.messageEditPhone.MsgLoginPhoneAgain'),
              type: 'warning'
            }).then((result)=>{
              if(result){
                // console.log(result)
                this.logout()
                localStorage.tologin = this.phonenewtologin
              }
            })
          }
        })
      }
    },
    disablebtnST1 () {
      if(this.radios === ''){
        return true
      }else{
        return false
      }
    },
    disablebtnST2 () {
      if(this.radios2 === ''){
        return true
      }else{
        return false
      }
    },
    logout () {
      this.$cookie.delete('tokenuser')
      this.$cookie.delete('status_login')
      localStorage.clear()
      this.$router.push({path: '/login', force: true})
      // if (process.env.LogoutOneid) {
      //   window.open(process.env.LogoutOneid, '_parent')
      // } else {
      //   this.$router.push({path: '/login', force: true})
      // }
    },
    newOtp(){
      this.counting = true
      this.axios.post(process.env.APImanage + '/otp_change_phone', {
        new_phone: this.phoneedit,
        tokenuser: this.token
      }).then((response)=> {
        // console.log(response)
        this.refcode_terminate = response.data.refcode
      }).catch((err)=>{
        console.log(err)
      })
    },
    newOtp2(){
      // console.log('new otp')
      this.counting2 = true
      this.axios.post(process.env.APImanage + '/otp_login_and_regis', {
        phone:this.phone
      }).then((response)=> {
        // console.log(response.data.refcode)
        this.refcode_terminate = response.data.refcode
      })
    },
    Terminate() {
      // console.log('terminate')
      this.progressTerminate = true
      this.axios.post(process.env.APImanage + '/otp_login_and_regis', {
        phone:this.phone
      }).then((response)=> {
        // console.log(response)
        // console.log(response.data.message)
        if(response.data.message === 'too many requests.'){
          this.progressTerminate = false
          this.refcode_terminate = ''
          this.$swal({
            title: this.$t('Settings.messageEditPhone.MsgTooManyRequest'),
            type: 'warning'
          })
        }else if(response.data.status === 'success'){
          this.progressTerminate = false
          this.refcode_terminate = response.data.refcode
        }
      })
      this.e1 = 3
    },
    handleCountdownEnd () {
      this.counting = false
    },
    handleCountdownEnd2 () {
      this.counting2 = false
    },
    handleCountdownProgress(data) {
      // console.log(data.days);
      // console.log(data.hours);
      // console.log(data.minutes);
      // console.log(data.seconds);
      // console.log(data.milliseconds);
      // console.log(data.totalDays);
      // console.log(data.totalHours);
      // console.log(data.totalMinutes);
      // console.log(data.totalSeconds);
      // console.log(data.totalMilliseconds);
    },
    transform(props) {
      Object.entries(props).forEach(([key, value]) => {
        // Adds leading zero
        const digits = value < 10 ? `0${value}` : value;
        // uses singular form when the value is less than 2
        const word = value < 2 ? key.replace(/s$/, '') : key;
        props[key] = `${digits}`;
      });
      return props;
    },
    countdown () {
      this.interv = setInterval(() => {
        this.date = moment(this.date.subtract(1, 'seconds'))
      }, 1000);
    },
  }
}
</script>

<style scoped>
>>>input.otp-input {
  width: 40px;
  height: 40px;
  padding: 5px;
  margin: 0 10px;
  font-size: 20px;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.3);
  text-align: "center";
}

.headerType{
 font-size: 18px;
 font-weight: bold;
}

.headerContent{
 font-size: 16px;
 font-weight: bold;
}

>>>.v-radio {
  align-items: flex-start;
  display: flex;
  height: auto;
  margin-right: 16px;
  outline: none;
}

>>>.previcon {
    background: transparent;
    box-shadow: none!important;
    border-radius: 50%;
    justify-content: center;
    min-width: 0;
    width: 0px !important;
    height: 12px;
}

.closeIcon{
  background: transparent;
  box-shadow: none!important;
  border-radius: 50%;
  justify-content: center;
  min-width: 0;
  width: 0px !important;
  height: 12px;
}
</style>


// WEBPACK FOOTER //
// src/components/chat/dialog/settings/Dialogeditphone.vue